import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { ServerURLEnum } from "src/models/others/ServerURLEnum";
import { StorageEnum } from "src/models/others/StorageEnum";
import { RequestBody } from "src/models/request/RequestBody";
import { ResponseBody } from "src/models/response/ResponseBody";
import { TokenStorageService } from "./token-storage.service";

@Injectable()
export class WebserviceService {
  private server_url = ServerURLEnum.Prod_url;

  private loginUrl = this.server_url + "login/user";
  private resetPasswordUrl = this.server_url + "login/resetpassword";
  private updatePasswordUrl = this.server_url + "login/updatepassword";
  private projectNameUrl = this.server_url + "task/getProjectName";
  private personprojectNameUrl = this.server_url + "task/getPersonProject";
  private roleUrl = this.server_url + "person/getRoles";
  private taskDetailUrl = this.server_url + "task/getTaskDetail";
  private MonthlyTaskDetailUrl = this.server_url + "task/getMonthlyTaskDetail";
  private TaskReportUrl = this.server_url + "task/getTaskReportDetail";
  private saveTaskUrl = this.server_url + "task/saveTaskDetail";
  private editTaskUrl = this.server_url + "task/updateTaskDetail";
  private deleteTaskUrl = this.server_url + "task/deleteTaskDetail";
  private saveLeaveUrl = this.server_url + "task/saveLeaveDetail";
  private employeeNameUrl = this.server_url + "task/getEmployeeName";
  private reviewTaskUrl = this.server_url + "task/reviewTask";
  private saveAssignTaskUrl = this.server_url + "task/saveAssignTaskDetail";
  private getpersonlsitUrl = this.server_url + "person/getPersonDetailList";
  private getAllpersonlsitUrl = this.server_url + "person/getAllPersonList";
  private savePersonDataUrl = this.server_url + "person/savePersonData";
  private leadNameUrl = this.server_url + "person/getLeadName";
  private monthlyLeaveReportUrl =
    this.server_url + "task/getMonthlyLeaveReport";
  private getIndLeaveDates = this.server_url + "person/getLeaveData";
  private getLeadEmployee = this.server_url + "person/getLeadEmployee";
  private getLeadEmpTask = this.server_url + "person/getLeadEmpTask";
  private getProjectsitUrl = this.server_url + "project/getProjectDetailList";
  private getFilterProjectsitUrl =
    this.server_url + "project/getFilterProjectDetailList";
  private saveProjectData = this.server_url + "project/saveProjectData";
  private deleteProjectData = this.server_url + "project/deleteProject";
  private saveLeaveDetailByAdmin =
    this.server_url + "task/saveLeaveDetailByAdmin";
  private revokeLeave = this.server_url + "task/revokeLeave";
  private getPersonProfileUrl = this.server_url + "person/getPersonProfile";
  private getReviewTaskDetail = this.server_url + "task/getReviewTaskDetail";
  private saveReviewTask = this.server_url + "task/saveReviewTask";
  private getHolidaysData = this.server_url + "task/getHolidays";
  private saveHolidays = this.server_url + "task/saveHolidays";
  private getAllocatedProjects =
    this.server_url + "project/getAllocatedProjects";
  private getPersonData = this.server_url + "person/getPersonData";
  private getNotReviewedTask =
    this.server_url + "task/getNotApprovedTaskDetail";
  private getConsolidatedTaskReportUrl =
    this.server_url + "task/getConsolidatedTaskReport";
  private getProjectResourceUrl =
    this.server_url + "project/getProjectResource";
  private saveClientHdr = this.server_url + "calendar/saveCalendarHdr";
  private getClientCalender = this.server_url + "calendar/getClientCalendar";
  private saveCalendarData = this.server_url + "calendar/saveCalendar";
  private getCalendar = this.server_url + "calendar/getCalendar";
  private deleteCalendar = this.server_url + "calendar/deleteHoliday";
  private deletePersonProject = this.server_url + "report/deletePersonProject";
  private consolidatedProjectReport =
    this.server_url + "report/getConsolidatedProjectReport";
  private projectWorkingDays = this.server_url + "report/getProjectWorkingDays";
  private allproject = this.server_url + "project/getAllProject";
  private getPersonConsolidatedTaskReportUrl =
    this.server_url + "task/getConsolidatedTaskReportForPerson";
  private getLeadAllocationProject =
    this.server_url + "project/getLeadAllocationProject";
  private getProjetcEmpTaskEfforts =
    this.server_url + "project/getProjetcEmpTaskEfforts";

  private getCurrentAllocation = this.server_url + "project/getCurrentAllocationReport";
  private getEmployeesWorkReport = this.server_url + "task/getEmployeesWorkDayReport"
  private getProjectsByPersonIdUrl = this.server_url + "report/getProjectListByPersonIds";
  private getPersonProfilePhotoUrl = this.server_url + "person/getPersonProfilePhoto";
  private savePersonProfilePhotoUrl = this.server_url + "person/saveProfilePhoto";
  private getAllProfilePhotosUrl = this.server_url + "person/getAllProfilePhotos";

  constructor(
    private http: HttpClient,
    private router: Router,
    private token: TokenStorageService,
  ) { }

  addHeader(): any {
    return {
      Authorization:
        "Bearer " + localStorage.getItem(StorageEnum.getUserAccessToken),
    };
  }

  public navigateToLogin() {
    this.router.navigate(["/login"]);
  }

  public loginRequest(param: any): Observable<RequestBody> {
    return this.http.post<RequestBody>(this.loginUrl, param);
  }
  public resetPasswordRequest(param: any): Observable<RequestBody> {
    return this.http.post<RequestBody>(this.resetPasswordUrl, param);
  }
  public updatePasswordRequest(param: any): Observable<ResponseBody> {
    let header = { headers: this.addHeader() };
    return this.http.post<ResponseBody>(this.updatePasswordUrl, param, header);
  }
  public getProejctName(param: any): Observable<ResponseBody> {
    let header = { headers: this.addHeader() };
    return this.http.post<ResponseBody>(this.projectNameUrl, param, header);
  }

  public getPersonProejctName(param: any): Observable<ResponseBody> {
    let header = { headers: this.addHeader() };
    return this.http.post<ResponseBody>(
      this.personprojectNameUrl,
      param,
      header,
    );
  }

  public getRoles(param: any): Observable<ResponseBody> {
    let header = { headers: this.addHeader() };
    return this.http.post<ResponseBody>(this.roleUrl, param, header);
  }
  public getLeadName(param: any): Observable<ResponseBody> {
    let header = { headers: this.addHeader() };
    return this.http.post<ResponseBody>(this.leadNameUrl, param, header);
  }

  public getTaskDetail(param: any): Observable<RequestBody> {
    let header = { headers: this.addHeader() };
    return this.http.post<RequestBody>(this.taskDetailUrl, param, header);
  }
  public getMonthlyTaskDetail(param: any): Observable<RequestBody> {
    let header = { headers: this.addHeader() };
    return this.http.post<RequestBody>(
      this.MonthlyTaskDetailUrl,
      param,
      header,
    );
  }
  public getTaskReport(param: any): Observable<RequestBody> {
    let header = { headers: this.addHeader() };
    return this.http.post<RequestBody>(this.TaskReportUrl, param, header);
  }

  public getCurrentAllocationReport(param: any): Observable<RequestBody> {
    let header = { headers: this.addHeader() };
    return this.http.post<RequestBody>(this.getCurrentAllocation, param, header);
  }

  public saveTaskRequst(param: any): Observable<RequestBody> {
    let header = { headers: this.addHeader() };
    return this.http.post<RequestBody>(this.saveTaskUrl, param, header);
  }

  public saveAssignTaskRequst(param: any): Observable<RequestBody> {
    let header = { headers: this.addHeader() };
    return this.http.post<RequestBody>(this.saveAssignTaskUrl, param, header);
  }

  public editTaskRequst(param: any): Observable<RequestBody> {
    let header = { headers: this.addHeader() };
    return this.http.post<RequestBody>(this.editTaskUrl, param, header);
  }
  public deleteTaskRequst(param: any): Observable<RequestBody> {
    let header = { headers: this.addHeader() };
    return this.http.post<RequestBody>(this.deleteTaskUrl, param, header);
  }
  public saveLeaveRequest(param: any): Observable<RequestBody> {
    let header = { headers: this.addHeader() };
    return this.http.post<RequestBody>(this.saveLeaveUrl, param, header);
  }
  public getEmployeeName(param: any): Observable<RequestBody> {
    let header = { headers: this.addHeader() };
    return this.http.post<RequestBody>(this.employeeNameUrl, param, header);
  }
  public getEmployeeTask(param: any): Observable<RequestBody> {
    let header = { headers: this.addHeader() };
    return this.http.post<RequestBody>(this.employeeNameUrl, param, header);
  }
  public reviewTaskRequest(param: any): Observable<RequestBody> {
    let header = { headers: this.addHeader() };
    return this.http.post<RequestBody>(this.reviewTaskUrl, param, header);
  }

  public getpersonlsit(param: any): Observable<RequestBody> {
    let header = { headers: this.addHeader() };
    return this.http.post<RequestBody>(this.getpersonlsitUrl, param, header);
  }

  public getProjetcEmpTaskEffort(param: any): Observable<RequestBody> {
    let header = { headers: this.addHeader() };
    return this.http.post<RequestBody>(
      this.getProjetcEmpTaskEfforts,
      param,
      header,
    );
  }

  public getAllpersonlist(param: any): Observable<RequestBody> {
    let header = { headers: this.addHeader() };
    return this.http.post<RequestBody>(this.getAllpersonlsitUrl, param, header);
  }
  public savePersonData(param: any): Observable<RequestBody> {
    let header = { headers: this.addHeader() };
    return this.http.post<RequestBody>(this.savePersonDataUrl, param, header);
  }

  public saveProjectDetails(param: any): Observable<RequestBody> {
    let header = { headers: this.addHeader() };
    return this.http.post<RequestBody>(this.saveProjectData, param, header);
  }

  public saveReviewTaskDetail(param: any): Observable<RequestBody> {
    let header = { headers: this.addHeader() };
    return this.http.post<RequestBody>(this.saveReviewTask, param, header);
  }

  public saveHolidaysData(param: any): Observable<RequestBody> {
    let header = { headers: this.addHeader() };
    return this.http.post<RequestBody>(this.saveHolidays, param, header);
  }

  public saveCalenderHrdData(param: any): Observable<RequestBody> {
    let header = { headers: this.addHeader() };
    return this.http.post<RequestBody>(this.saveClientHdr, param, header);
  }

  public saveClientCalender(param: any): Observable<RequestBody> {
    let header = { headers: this.addHeader() };
    return this.http.post<RequestBody>(this.saveCalendarData, param, header);
  }

  public deleteProjectDetails(param: any): Observable<RequestBody> {
    let header = { headers: this.addHeader() };
    return this.http.post<RequestBody>(this.deleteProjectData, param, header);
  }

  public getmonthlyLeveReport(param: any): Observable<RequestBody> {
    let header = { headers: this.addHeader() };
    return this.http.post<RequestBody>(
      this.monthlyLeaveReportUrl,
      param,
      header,
    );
  }

  public getPersonProfile(param: any): Observable<RequestBody> {
    let header = { headers: this.addHeader() };
    return this.http.post<RequestBody>(this.getPersonProfileUrl, param, header);
  }

  public getPersonProfilePhoto(param: any): Observable<RequestBody> {
    let header = { headers: this.addHeader() };
    return this.http.post<RequestBody>(this.getPersonProfilePhotoUrl, param, header);
  }

  public getPersonDetail(param: any): Observable<RequestBody> {
    let header = { headers: this.addHeader() };
    return this.http.post<RequestBody>(this.getPersonData, param, header);
  }

  public getLeadAllocationProjects(param: any): Observable<RequestBody> {
    let header = { headers: this.addHeader() };
    return this.http.post<RequestBody>(
      this.getLeadAllocationProject,
      param,
      header,
    );
  }

  public getReviewDetail(param: any): Observable<RequestBody> {
    let header = { headers: this.addHeader() };
    return this.http.post<RequestBody>(this.getReviewTaskDetail, param, header);
  }

  public getLeaveDates(param: any): Observable<RequestBody> {
    let header = { headers: this.addHeader() };
    return this.http.post<RequestBody>(this.getIndLeaveDates, param, header);
  }

  public getHolidays(param: any): Observable<RequestBody> {
    let header = { headers: this.addHeader() };
    return this.http.post<RequestBody>(this.getHolidaysData, param, header);
  }

  public getCalendarData(param: any): Observable<RequestBody> {
    let header = { headers: this.addHeader() };
    return this.http.post<RequestBody>(this.getCalendar, param, header);
  }

  public deleteCalendars(param: any): Observable<RequestBody> {
    let header = { headers: this.addHeader() };
    return this.http.post<RequestBody>(this.deleteCalendar, param, header);
  }

  public getClientCalenderData(param: any): Observable<RequestBody> {
    let header = { headers: this.addHeader() };
    return this.http.post<RequestBody>(this.getClientCalender, param, header);
  }

  public getLeadEmployeeData(param: any): Observable<RequestBody> {
    let header = { headers: this.addHeader() };
    return this.http.post<RequestBody>(this.getLeadEmployee, param, header);
  }

  public getLeadEmployeeTask(param: any): Observable<RequestBody> {
    let header = { headers: this.addHeader() };
    return this.http.post<RequestBody>(this.getLeadEmpTask, param, header);
  }

  public getProjectList(param: any): Observable<RequestBody> {
    let header = { headers: this.addHeader() };
    return this.http.post<RequestBody>(this.getProjectsitUrl, param, header);
  }

  public getProjectResource(param: any): Observable<RequestBody> {
    let header = { headers: this.addHeader() };
    return this.http.post<RequestBody>(
      this.getProjectResourceUrl,
      param,
      header,
    );
  }

  public getAllocatedProject(param: any): Observable<RequestBody> {
    let header = { headers: this.addHeader() };
    return this.http.post<RequestBody>(
      this.getAllocatedProjects,
      param,
      header,
    );
  }

  public getFilterProjectList(param: any): Observable<RequestBody> {
    let header = { headers: this.addHeader() };
    return this.http.post<RequestBody>(
      this.getFilterProjectsitUrl,
      param,
      header,
    );
  }

  public saveLeaveDetailsByAdmin(param: any): Observable<RequestBody> {
    let header = { headers: this.addHeader() };
    return this.http.post<RequestBody>(
      this.saveLeaveDetailByAdmin,
      param,
      header,
    );
  }

  public deleteRevokeLeave(param: any): Observable<RequestBody> {
    let header = { headers: this.addHeader() };
    return this.http.post<RequestBody>(this.revokeLeave, param, header);
  }

  public getNotApprovedTask(param: any): Observable<RequestBody> {
    let header = { headers: this.addHeader() };
    return this.http.post<RequestBody>(this.getNotReviewedTask, param, header);
  }

  public getConsolidatedTaskReport(param: any): Observable<RequestBody> {
    let header = { headers: this.addHeader() };
    return this.http.post<RequestBody>(
      this.getConsolidatedTaskReportUrl,
      param,
      header,
    );
  }

  public getEmployeesWorkReports(param: any): Observable<RequestBody> {
    let header = { headers: this.addHeader() };
    return this.http.post<RequestBody>(
      this.getEmployeesWorkReport,
      param,
      header,
    );
  }

  public getPersonConsolidatedTaskReport(param: any): Observable<RequestBody> {
    let header = { headers: this.addHeader() };
    return this.http.post<RequestBody>(
      this.getPersonConsolidatedTaskReportUrl,
      param,
      header,
    );
  }

  public getPersonConsolidatedTaskReportBlob(param: any): Observable<Blob> {
    const options: any = {
      headers: this.addHeader(),
      responseType: "blob",
    };
    return this.http.post(
      this.getPersonConsolidatedTaskReportUrl,
      param,
      options,
    ) as unknown as Observable<Blob>;
  }

  public getallProjects(): Observable<RequestBody> {
    let header = { headers: this.addHeader() };
    return this.http.get<RequestBody>(this.allproject, header);
  }

  public getConsolidatedProjectReport(param: any): Observable<RequestBody> {
    let header = { headers: this.addHeader() };
    return this.http.post<RequestBody>(
      this.consolidatedProjectReport,
      param,
      header,
    );
  }

  public getPersonProjectDays(param: any): Observable<RequestBody> {
    let header = { headers: this.addHeader() };
    return this.http.post<RequestBody>(this.projectWorkingDays, param, header);
  }

  public removePersonProjectData(param: any): Observable<RequestBody> {
    let header = { headers: this.addHeader() };
    return this.http.post<RequestBody>(this.deletePersonProject, param, header);
  }

  public getProjecctsByPersonId(param: any): Observable<ResponseBody> {
    let header = { headers: this.addHeader() };
    return this.http.post<ResponseBody>(this.getProjectsByPersonIdUrl, param, header);
  }

  public saveProfilePhoto(param: any): Observable<RequestBody> {
    let header = { headers: this.addHeader() };
    return this.http.post<RequestBody>(this.savePersonProfilePhotoUrl, param, header);
  }

  public getAllProfilePhotos(param: any): Observable<ResponseBody> {
    let header = { headers: this.addHeader() };
    return this.http.post<ResponseBody>(this.getAllProfilePhotosUrl, param, header);
  }
}
